import { useState } from 'react';

const SvgIcon = ({ size = '16', color = "#000" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      version="1.1"
      viewBox="0 0 16 16"
    >
      <path
        fill={color}
        strokeWidth="1"
        d="M6.857 9.143H0V6.857h6.857V0h2.286v6.857H16v2.286H9.143V16H6.857Z"
      ></path>
    </svg>
  );
};

export default SvgIcon;

//import { useState } from 'react';
//
//const SvgIcon = ({fillColor = "#000", hoverColor}) => {
//  let [fillStyle, setFillStyle] = useState(fillColor);
//
//  return (
//    <div
//      onMouseEnter={() => { setFillStyle(typeof hoverColor === 'string' ? hoverColor : fillColor); }}
//      onMouseLeave={() => { setFillStyle(fillColor); }}
//    >
//      <svg
//        xmlns="http://www.w3.org/2000/svg"
//        id="svg847"
//        width="16"
//        height="16"
//        fill="none"
//        version="1.1"
//        viewBox="0 0 16 16"
//      >
//        <path
//          id="path845"
//          fill={fillStyle}
//          strokeWidth="1"
//          d="M6.857 9.143H0V6.857h6.857V0h2.286v6.857H16v2.286H9.143V16H6.857Z"
//        ></path>
//      </svg>
//    </div>
//  );
//};
//
//export default SvgIcon;
